<template>
  <div class="relative p-4">
    <div class="absolute top-2 right-2 z-10">
      <div class="flex place-items-center p-1 text-zinc-500 dark:text-zinc-50 cursor-pointer rounded-full hover:bg-zinc-50/5 transition-transform" :class="expanded && '-rotate-180'" @click="toggleExpanded">
        <IconChevronDown class="size-8" />
      </div>
    </div>
    <div
      class="w-full overflow-hidden dark:bg-zinc-800 text-zinc-700 dark:text-zinc-200 transform-gpu transition-all duration-250 ease-in-out" :class="expanded ? 'max-h-[2400px]' : 'max-h-36'">
      <div class="summary" v-html="summary"></div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import IconChevronDown from "@/components/icons/IconChevronDown.vue";

defineProps({
  summary: String
});

const expanded = ref(false);

const toggleExpanded = () => {
  expanded.value = !expanded.value;
};

</script>
